import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as artistAnalytics from '@webapp/sdk/analytics';
import { Action } from 'redux';
import {
  GetArtistAnalytics,
  GetArtistAnalyticsSuccess,
  GetArtistAnalyticsError,
  UpdateField,
} from '../action-creators';
import { GET_ARTIST_ANALYTICS } from '../actions';
import AppState from '../../state';
import store from '@webapp/store';
import { AnalyticsResults } from '@services/analytics/types/analytics-results';

export const getArtistAnalyticsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, GetArtistAnalytics>(GET_ARTIST_ANALYTICS),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const { timeframe, filters } = state.artistAnalytics;
        const params = {
          artistId:
            process.env.REACT_APP_STAGE === 'development' ||
            process.env.REACT_APP_STAGE === 'faizy' ||
            process.env.REACT_APP_STAGE === 'staging'
              ? (process.env.REACT_APP_ANALYTICS_ARTIST as string)
              : action.artistId || (state.artist.active?.id as string),
          start: timeframe.start,
          end: timeframe.end,
          dsps: filters.dsps,
          range: filters.range,
          queryDataType: action.queryDataType,
        };
        if (action.isInitial) {
          params.dsps = state.categories.lists.platform.map(
            (p) => p.metadata.id
          );
        }
        const results = await artistAnalytics.query(params);

        if (state.artistAnalytics.filters?.range === 'allTime') {
          const filterDays = getAllTimeFilterDays(results);
          store.dispatch(new UpdateField('days', filterDays.toString()));
        }

        return new GetArtistAnalyticsSuccess(results, action.queryDataType);
      } catch (err) {
        return new GetArtistAnalyticsError(err.message);
      }
    })
  );

const getAllTimeFilterDays = (results: AnalyticsResults): number => {
  const downloadsStartYear = results.downloads?.timeseries?.[0].date
    ? new Date(results.downloads?.timeseries?.[0].date).getFullYear()
    : Infinity;
  const savesStartYear = results.saves?.timeseries?.[0].date
    ? new Date(results.saves?.timeseries?.[0].date).getFullYear()
    : Infinity;
  const streamsStartYear = results.streams?.timeseries?.[0].date
    ? new Date(results.streams?.timeseries?.[0].date).getFullYear()
    : Infinity;
  const listenersStartYear = results.listeners?.timeseries?.[0].date
    ? new Date(results.listeners?.timeseries?.[0].date).getFullYear()
    : Infinity;

  const startDateYear = Math.min(
    downloadsStartYear,
    savesStartYear,
    streamsStartYear,
    listenersStartYear
  );

  if (startDateYear !== Infinity) {
    const currentYear = new Date().getFullYear();
    return (currentYear - startDateYear) * 365;
  }

  return 365;
};
